module.exports = __webpack_public_path__ + "img/logo-en-left-gradiant.2d8b6bc.svg";